export default __webpack_public_path__ + "static/media/Churchill.491350c2.jpg";